import styled from 'styled-components';

/** Keeps the affixes ($, %) on the figure's baseline and the digits tabular so
 *  the live tween doesn't shift the layout. */
export const Root = styled.span`
  display: inline-flex;
  align-items: baseline;
  font-variant-numeric: tabular-nums;
`;

export const Affix = styled.span`
  display: inline-block;
`;
